<script lang="tsx">
  import {
    defineComponent, computed, PropType,
  } from 'vue'
  import SingleSelect from '@xhs/yam-beer/cmp/dataEntry/Select/SingleSelect.vue'
  import { ItemObjectType } from '../../../compose/options/useOptions'
  import { BeerStyleObj } from '../../../core'

  export default defineComponent({
    name: 'PagerOption',
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      modelValue: {
        type: Number as PropType<number>,
        required: true,
      },
      sizeList: {
        type: Array as PropType<number[]>,
        default: () => ([10, 20, 30, 50]),
      },
    },
    setup(props, { attrs }) {
      const options = computed(() => {
        const lst = Array.from(new Set(props.sizeList.concat(props.modelValue)))
          .filter(i => i)
          .sort((a, b) => a - b)
          .map(num => ({
            name: `${num}条/页`,
            value: num,
          } as ItemObjectType))
        return lst
      })
      const width = computed(() => {
        if (options.value.length < 1) {
          return 95
        }
        const val = options.value[options.value.length - 1].value
        if (val < 100) {
          return 95
        }
        if (val < 1000) {
          return 103
        }
        return 111
      })
      return () => (
      <SingleSelect
        aria-label="pager-options"
        bs={{
          mr: 8,
          width: width.value,
          ...props.bs,
        }}
        fixed
        options={options.value}
        modelValue={props.modelValue}
        {...attrs}
      />
    )
    },
  })
</script>
